/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { Store } from '@ngxs/store';
import { ReportFilterService } from '@reports/services/report-filter.service';
import { ReportButtonComponent } from './report-button.component';

@NgModule({
    imports: [ ReportButtonComponent ],
    providers: [ Store, ReportFilterService ]
})
export class ReportButtonModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(ReportButtonComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-report-button', el);
    }
}
